import { fetcher } from '@commenda/utils';
import { BulkUploadProps, BulkUploadResponse } from './types';

export async function bulkUploadCustomers(
  body: BulkUploadProps,
  token: string
): Promise<{
  success: boolean;
  data?: BulkUploadResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/customers/bulk/csv`,
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error uploading customers:', errorData);
      return {
        success: false,
        error: errorData.message || 'Failed to upload customers',
      };
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to upload customers';
    console.error('Failed to upload customers:', error);
    return {
      success: false,
      error: errorMessage,
    };
  }
}
